// Selection survives page replacement. Existing values and proposed labels occupy
// separate namespaces, so a new label can never overwrite an existing record ID.
export class AsyncSelectDraft {
  static key(value, created = false) {
    return JSON.stringify([created ? 'new' : 'existing', String(value)]);
  }

  constructor(saved, selected = saved, created = []) {
    this.saved = new Set(saved.map(value => AsyncSelectDraft.key(value)));
    this.selected = new Set([
      ...selected.map(value => AsyncSelectDraft.key(value)),
      ...created.map(label => AsyncSelectDraft.key(label, true))
    ]);
  }

  set(key, checked) {
    if (checked) this.selected.add(key);
    else this.selected.delete(key);
  }

  state(key) {
    if (this.saved.has(key) && !this.selected.has(key)) return 'removed';
    if (!this.saved.has(key) && this.selected.has(key)) return 'added';
    return '';
  }

  atTop(key) {
    return this.saved.has(key) || this.selected.has(key);
  }

  baseline() { return JSON.stringify([...this.saved].sort()); }
  snapshot() { return JSON.stringify([...this.selected].sort()); }

  submission() {
    const values = [], creations = [];
    this.selected.forEach(key => {
      const [kind, value] = JSON.parse(key);
      (kind === 'new' ? creations : values).push(value);
    });
    return { values, creations };
  }
}
